import styled from 'styled-components';

import { TextShimmer } from '../TextShimmer/TextShimmer';
import { theme } from '../ui/theme';

const LoadingOverlay = styled.div<{ $isLoading: boolean }>`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: color-mix(in srgb, ${theme.colors.background.default} 72%, transparent);
    backdrop-filter: blur(4px);
    opacity: ${({ $isLoading }) => ($isLoading ? 1 : 0)};
    pointer-events: ${({ $isLoading }) => ($isLoading ? 'auto' : 'none')};
    transition: opacity 150ms ease-in-out;
`;

interface ContentLoadingOverlayProps {
    isLoading: boolean;
    label: string;
}

export const ContentLoadingOverlay = ({ isLoading, label }: ContentLoadingOverlayProps) => (
    <LoadingOverlay $isLoading={isLoading}>
        <TextShimmer variant="body" fontWeight={600}>
            {label}
        </TextShimmer>
    </LoadingOverlay>
);
